const config = {
    appSchema: "pado://",
    backUrl : process.env.NODE_ENV === 'production' ? 'https://pado.mdpeople.co.kr/' : 'http://115.85.182.235/',
};


export default config;
